import {
    ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Host, Input, Output, ViewChild
} from '@angular/core';

import { SelectComponent } from './select.component';

@Component({
  selector: 'app-option',
  templateUrl: './option.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionComponent {
  @Input() value: string = '';
  @ViewChild('content', { static: false }) content!: ElementRef<HTMLElement>;
  @Output() selected = new EventEmitter<void>();
  
  protected readonly isMobile = window.innerWidth < 768 || screen.width < 768;

  constructor(@Host() private selectComp: SelectComponent) {}
  select() {
    this.selectComp.selected = this.value;
    // console.log('selected display value ', this.content.nativeElement.innerText);
    this.selectComp.displayValue = this.content.nativeElement.innerText;
    if (!this.selectComp.multiple) this.selectComp.isActive = false;
    this.selected.emit();
  }
  get isSelected() {
    const selected = this.selectComp.selected.toLowerCase();
    const value = this.value.toLowerCase();
    const isMultiple = this.selectComp.multiple;
    if (!isMultiple) return selected === value;
    const splittedValues = selected.split(',');
    return splittedValues.includes(value);
  }

  ngAfterViewInit() {
    // console.log(this.value);
    if (!this.isSelected) return;
    this.selectComp.displayValue = this.content.nativeElement.innerText;
  }

  updateDisplay() {
    this.selectComp.displayValue = this.content.nativeElement.innerText;
  }
}
